// extracted by mini-css-extract-plugin
export default {"login-form-builder":"login-form-builder_login-form-builder__LjeVx","label":"login-form-builder_label__Myx2u","error":"login-form-builder_error__cVEBe"};